import {Serializer} from "../interfaces/serializer";
import {SavedReport} from "../interfaces/saved-reports";
import {BehaviorSubject, Observable, switchMap} from 'rxjs';
import {UserComponentObject, UserComponentObjects} from './user-component-object';
import {FolderComponentObject, FolderComponentObjects} from './folder-component-object';
import {environment} from '../../../environments/environment';
import {AdRequestParams} from "../interfaces/ad-reports";

export type SavedReportComponentObjects = Array<SavedReportComponentObject>;

export class SavedReportComponentObject {
  public payload: Serializer<SavedReport>;

  public readonly name$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly url$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly publicUrl$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly publicPassword$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly isFavorite$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isPublic$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly parameters$: BehaviorSubject<Partial<AdRequestParams> > = new BehaviorSubject<Partial<AdRequestParams> >(null);

  public readonly owner$: BehaviorSubject<UserComponentObject> = new BehaviorSubject<UserComponentObject>(null);
  public readonly folder$: BehaviorSubject<FolderComponentObject> = new BehaviorSubject<FolderComponentObject>(null);

  public readonly path$: Observable<FolderComponentObjects> = this.folder$.pipe(
    switchMap((folder: FolderComponentObject): BehaviorSubject<FolderComponentObjects> => folder.fullPath$)
  );

  constructor(
    private _payload: Serializer<SavedReport>
  ) {
    this.update(_payload);
  }

  public loading(): void {
    this.loading$.next(true);
  }

  public init(users: UserComponentObjects, folders: FolderComponentObjects): void {
    this.owner$.next(users.find((user: UserComponentObject): boolean => user.payload.id == this.payload.relationships.user.data?.id));
    this.folder$.next(
      folders.find((folder: FolderComponentObject): boolean => folder.payload.id == this.payload.relationships.saved_reports_folder.data?.id) ||
      folders.find((folder: FolderComponentObject): boolean => folder.payload.id == null)
    );

    this.payload.attributes.saved_reports_folder_id = this.folder$.value.payload.id;
  }

  public update(payload: Serializer<SavedReport>): void {
    this.payload = payload;
    this.name$.next(payload.attributes.name);
    this.url$.next(`${payload.attributes.data_set_id}/ad-reports/${payload.attributes.report_type}/saved/${payload.id}`);
    this.publicUrl$.next(`${environment.baseUrl}/public-reports/password/${payload.attributes.uuid}`);
    this.publicPassword$.next(payload.attributes.password);
    this.isPublic$.next(payload.attributes.is_public);
    this.isFavorite$.next(payload.attributes.is_favorite);

    this.loading$.next(false);
  }

  public setParameters(parameters: Partial<AdRequestParams>): any {
    this.parameters$.next(parameters);
    this.payload.attributes.parameters = parameters;
  }

}
